import { datadogLogs } from '@datadog/browser-logs';

export function logTokenRefreshEvent(eventName: string, context = {}) {
  datadogLogs.logger.info('TokenRefreshEvent', {
    eventName,
    ...context,
  });
}
